import * as React from "react";
import Spinner from '../../common/components/spinner/spinner';
import Translate from '../../common/functions/translate';
import * as Constants from '../../common/constants';
import AlphabeticalFilter from '../../common/components/alphabeticalFilter/alphabeticalFilter';
import Drawer from '@material-ui/core/Drawer';
import Fab from '@material-ui/core/Fab';
import Paper from '@material-ui/core/Paper';
import InputBase from '@material-ui/core/InputBase';
import IconButton from '@material-ui/core/IconButton';
import DiseaseService from '../../services/diseaseService';
import { DiseaseGridModel, DiseaseForGridModel, DiseaseFilterSettingsModel } from "../../models";
import SearchIcon from '@material-ui/icons/Search';
import Growl from '../../common/components/alertMessage/growl';
import DiseaseList from './diseaseList';
import { connect } from 'react-redux';

interface IProps {
    history?: any,
    location?: any,
    lang: string,
}

interface IState {
    diseases: Array<DiseaseForGridModel>;
    isLoading: boolean;
    validationMessage: string;
    from: number;
    numberOfRows: number;
    totalRecordsCount: number;
    diseaseSettings: DiseaseFilterSettingsModel;
    drawer: boolean;
    searchText: string;
}

const initFrom = 0;
const numberOfRows = 20;

class DiseaseComponent extends React.Component<IProps, IState> {

    diseaseService = new DiseaseService(this.props.lang);
    messages: any;
    growl: any;

    constructor(props: IProps) {
        super(props);

        this.state = {
            validationMessage: '',
            diseases: new Array<DiseaseForGridModel>(0),
            isLoading: false,
            from: initFrom,
            numberOfRows: numberOfRows,
            totalRecordsCount: 0,
            diseaseSettings: new DiseaseFilterSettingsModel(),
            drawer: false,
            searchText: ''
        };
    }

    // events
    componentDidMount() {
        window.addEventListener('scroll', this.onScroll);
        this.getAllDiseases(this.state.from, this.state.numberOfRows, true);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.onScroll);
    }

    onScroll = () => {
        let scrollY = window.scrollY ? window.scrollY : window.pageYOffset;
        if (window.innerHeight + scrollY >= document.body.offsetHeight - 250 &&
            this.state.totalRecordsCount > this.state.diseases.length && !this.state.isLoading) {
            this.paginatorClick({ first: this.state.from + this.state.numberOfRows }, false);
        }
    };

    // methods
    getAllDiseases(from: number, numberOfRows: number, isInit: boolean) {
        this.setState({
            isLoading: true
        });

        const { diseaseSettings } = this.state;

        this.diseaseService.getAllDiseases(from, numberOfRows, diseaseSettings, this.props.lang).then(
            (data: any) => {
                if (isInit) {
                    this.setState({
                        isLoading: false,
                        from: from,
                        diseases: data.diseases,
                        totalRecordsCount: data.totalRecordsCount
                    });
                }
                else {
                    this.setState({
                        isLoading: false,
                        diseases: [...this.state.diseases, ...data.diseases],
                        totalRecordsCount: data.totalRecordsCount
                    });
                }
            })
            .catch(error => {
                this.growl.show({ severity: 'error', summary: error.message });
                this.setState({
                    isLoading: false
                });
            });
    }

    paginatorClick = (e, isInit: boolean) => {
        this.setState({ from: e.first }, () => this.getAllDiseases(this.state.from, this.state.numberOfRows, isInit));
    }

    handleAlphaIndexChange = (e, letter: string) => {
        const currentSettings: DiseaseFilterSettingsModel = { ...this.state.diseaseSettings };
        if (currentSettings.alphaIndex == letter) {
            letter = '';
        }
        currentSettings.alphaIndex = letter;
        this.setState({
            diseaseSettings: {
                ...currentSettings
            }
        }, () => this.getAllDiseases(0, this.state.numberOfRows, true));
        this.toggleDrawer(false);
    }


    handleChange = (key, value) => {
        this.setState({ searchText: value });
    };

    handleSearchButtonClick = () => {

        const { searchText } = this.state;

        let searchTextTrim = searchText.trim();

        if (searchTextTrim) {
            const currentSettings: DiseaseFilterSettingsModel = { ...this.state.diseaseSettings };
            currentSettings.diseaseName = searchText;
            this.setState({
                diseaseSettings: {
                    ...currentSettings
                }
            }, () => this.getAllDiseases(0, this.state.numberOfRows, true));
            this.toggleDrawer(false);
        }
    }

    handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            this.handleSearchButtonClick();
            this.toggleDrawer(false);
        }
    }

    toggleDrawer = (open) => {
        this.setState({
            drawer: open
        });
    };

    handleShowAllClick = (event) => {
        event.preventDefault();
        this.setState({
            diseaseSettings: new DiseaseFilterSettingsModel(),
            from: 0
        }, () => this.getAllDiseases(0, this.state.numberOfRows, true));
    }

    // render
    public render() {

        const { diseases, isLoading, diseaseSettings, totalRecordsCount, searchText } = this.state;
        let titleText = '';

        let showAllLink = false;

        if (diseaseSettings && diseaseSettings.alphaIndex) {
            titleText = ` ${Translate('starts with')} '${diseaseSettings.alphaIndex}' `;
            showAllLink = true;
        }

        if (diseaseSettings && diseaseSettings.diseaseName) {
            titleText = ` ${Translate('contain text')} '${diseaseSettings.diseaseName}' `;
            showAllLink = true;
        }

        return (
            <div className="app-content">

                <Growl ref={(el) => this.growl = el} />


                <h2>{Translate('Diseases')}{titleText}</h2>

                <Fab focusRipple={false} color="primary" aria-label="Search" size="small" onClick={() => this.toggleDrawer(true)} className="floating-action-button">
                    <SearchIcon />
                </Fab>

                {!isLoading ?
                    <div className="list-items-count-info">
                        <span className='list-items-count-info-number'>{totalRecordsCount}</span> {Translate('ResulFound')}
                    </div> : null}

                {showAllLink ?
                    <div style={{ margin: '10px 0' }}>
                        <a href='' onClick={(e) => this.handleShowAllClick(e)}>{Translate('All diseases')}</a>
                    </div> : null}

                <DiseaseList
                    diseases={diseases}
                    history={this.props.history}
                    lang={this.props.lang}
                />

                {isLoading ? <Spinner inlineSpinner={true} /> : null}

                <>
                    <Drawer anchor="bottom" open={this.state.drawer} onClose={() => this.toggleDrawer(false)}>
                        <div
                            tabIndex={0}
                            role="button"
                        >
                            <div className="user-condition-panel drawer-panel">
                                <div className="user-condition-filter">
                                    <h3>{Translate('SearchDiseaseInDatabase')}</h3>
                                    <Paper style={Constants.inputWithButton.root} elevation={1}>
                                        <InputBase style={Constants.inputWithButton.input} placeholder={Translate('EnterDiseaseName')}
                                            onChange={(e) => this.handleChange('searchByName', e.target['value'])}
                                            onKeyPress={this.handleKeyPress}
                                            value={searchText ? searchText : ""}
                                        />
                                        <IconButton
                                            color="primary"
                                            style={Constants.inputWithButton.iconButton}
                                            onClick={this.handleSearchButtonClick}
                                        >
                                            <SearchIcon />
                                        </IconButton>
                                    </Paper>
                                </div>
                                <div className="user-condition-filter">
                                    <h4>{Translate('BrowseAlphabetically')}</h4>
                                    <AlphabeticalFilter
                                        handleAlphaIndexChange={this.handleAlphaIndexChange}
                                        filters={["bg", "en"]}
                                        buttonStyle={true}
                                        letterClassName="p-button-secondary p-button-raised"
                                        activeLetter={diseaseSettings.alphaIndex}
                                    />
                                </div>
                            </div>
                        </div>
                    </Drawer>

                </>
            </div>
        );
    }
}

const mapsStateToProps = state => {
    return {
        lang: state.common.lang
    };
}

export default connect(mapsStateToProps, null)(DiseaseComponent);

